<template>
  <div>
    <classroom></classroom>
  </div>
</template>

<script>
import classroom from '@views/appletManagement/classroom'
export default {
  data() {
    return {
      
    };
  },
  components:{
    classroom
  },

  mounted() {
    
  },

  methods: {
    
  },
};
</script>

<style lang="scss" scoped>

</style>